<template>
    <div class="row">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <b-card header-class="bg-transparent border-success" class="border border-success">
                            <template v-slot:header>
                                <h5 class="my-0 text-success">
                                    <i class="mdi mdi-alert-circle-outline mr-3"></i>Se registro el expediente
                                </h5>
                            </template>

                            <h3><strong>Constancia de registro en el sistema.</strong></h3>
                            <h4> <strong> Tipo de tramite:</strong>{{(typeof  model.tipo!='undefined')? model.tipo.descripcion:"NA" }}</h4>
                            <h4><strong>Numero de expediente:</strong> {{model.numero_referencia}}</h4>
                            <p>
                            </p>
                            <p>
                                <strong>Numero documento:</strong>{{model.documento_identidad_numero}}
                            </p>
                            <p>
                                <strong>Nombres:</strong>{{model.denominacion}}
                            </p>
                            <p>
                                <strong>Correo:</strong>{{model.correo}}
                            </p>
                            <p>
                                <strong>Celular:</strong>{{model.celular}}
                            </p>
                            <p>
                                <strong>Fecha de registro:</strong>{{formatDate(model.created_at)}}
                            </p>
                            <p class="text-danger"><strong>Nota importante:Se ha registrado exitosamente en el sistema. Sin embargo, es importante que realice un seguimiento constante de su trámite.</strong></p>
                            <p>El servicio de notificación de sms esta temporalmente desactivado</p>
                            <p>
                            </p>
                            <button class="btn btn-primary" onclick="javascript:window.print()">Imprimir</button>
                        </b-card>
                    </div>
                </div>
            </div>


    </div>
</template>

<script>

    export default {
        name: "constancia-recepcion",
        props: {
            model:{
                type:Object
            },
        },
        data(){
            return {
                server: process.env.VUE_APP_BACKEND
            }
        },

        methods :{
            formatDate(value){
                if (value) {
                    return this.$moment(String(value)).format('DD/MM/YYYY HH:mm')
                }
            }
        }
    }

</script>

<style scoped>


</style>
